import React from "react";
import { Pie } from "react-chartjs-2";
import NurserylevelCard from "../Cards/NurserylevelCard";

export const CardComptwo = () => {
  return (
      <div className=" p-2 pb-3 px-0 mt-3" >
     <div className="col-12 col-md-7 col-lg-8 mb-xl-0 align-self-center align-items-center">
        <h6 className="fw-bold px-1 text-dark pt-1 pb-1">
        Nursery level
        </h6>
      </div>
      <div className="row  mr-1 mr-lg-0 ">
        <NurserylevelCard
          // icon={<FileText />}
          img="./static/assets/img/dashboard/surveyor.png"
          title="Details of Surveyor"
          count="346"
          className=" col-12 col-lg-4 mt-2 mt-lg-0 "
          cardBodyBg="card-body"
          background="#1b306661"
          duration="Since Last Year"
          button="onClick={() => handleChange()}"
        // navigateTo="/Branch-Enquiry-received"
        />
        <NurserylevelCard
          // icon={<Check />}
          img="./static/assets/img/dashboard/Nursery.png"
          title="Details of Individual Nursery"
          count="346"
          background="#ff6500b8"
          className=" col-12 col-lg-4 mt-2 mt-lg-0 "
          cardBodyBg="card-body"
          duration="Since Last Year"
        // navigateTo="/Branch-Enquiry-Approved"
        />
        <NurserylevelCard
          // icon={<Clock />}
          img="./static/assets/img/dashboard/saplings.png"
          title="Details of saplings present in the individual nursery"
          className=" col-12 col-lg-4 mt-2 mt-lg-0 "
          cardBodyBg="card-body"
          count="346"
          // percentage="56.5%"
          background="#1b306661"
          duration="Since Last Year"
        // navigateTo="/Branch-Enquiry-pending"
        />
      </div>   
    </div>
  );
};
